module.exports = __webpack_public_path__ + "img/1589400554.472b028c.jpg";